import { useContext } from 'react';
import { ReturnPortalContext } from '../contexts/ReturnPortalContext';

export function useReturnPortalCountry(): string | undefined {
  const { countryCode } = useContext(ReturnPortalContext);
  return countryCode;
}
